import React from "react";

export const dot_selector = number => {
  let list = [];
  for (let i = 1; i < number; i++) {
    list.push(<li value={i} key={i} />);
  }
  return (
    <div className="select_helper">
      <ul className="selector">
        <li value="0" active="1" />
        {list}
      </ul>
    </div>
  );
};



// WEBPACK FOOTER //
// ./common/dot_selector.jsx